module.exports = __webpack_public_path__ + "img/delete.0b23a061.svg";